import { createClient } from '@supabase/supabase-js';

// Env-aware target. Defaults are the normal REMOTE project (unchanged) so production builds behave exactly as
// before. For the LOCAL Field Assist demo, set VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY in `.env.local`
// (see .env.local.example) to point the app at the local Supabase stack. `.env.local` is gitignored; never commit
// real keys. When pointed at localhost, the `.parcelink.org` cookie domain below does not apply (the browser
// session is held in localStorage), so local sign-in still works.
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://wgqfslalqgnnxryezuxg.supabase.co';
export const SUPABASE_URL = supabaseUrl; // for building public function URLs (e.g. calendar feed links)
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'sb_publishable_HEtxIoyMpe74ooXKpbsG8g_nHbleDWM';
const isLocalSupabase = /^(https?:\/\/)?(127\.0\.0\.1|localhost)(:\d+)?/.test(supabaseUrl);

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: window.localStorage,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    // Host-only cookie for the local demo (localhost can't set a `.parcelink.org` cookie); remote unchanged.
    cookieOptions: isLocalSupabase
      ? { path: '/', sameSite: 'Lax', secure: false }
      : { domain: '.parcelink.org', path: '/', sameSite: 'Lax', secure: true },
  },
});